/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AccessRequestApprovalType {
    LocalAdministrator = 'LocalAdministrator',
    ExternalAdministrator = 'ExternalAdministrator',
    NoApproval = 'NoApproval',
    ExternalApplicationAdministrator = 'ExternalApplicationAdministrator'
}


export function instanceOfAccessRequestApprovalType(value: any): boolean {
    for (const key in AccessRequestApprovalType) {
        if (Object.prototype.hasOwnProperty.call(AccessRequestApprovalType, key)) {
            if (AccessRequestApprovalType[key as keyof typeof AccessRequestApprovalType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccessRequestApprovalTypeFromJSON(json: any): AccessRequestApprovalType {
    return AccessRequestApprovalTypeFromJSONTyped(json, false);
}

export function AccessRequestApprovalTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestApprovalType {
    return json as AccessRequestApprovalType;
}

export function AccessRequestApprovalTypeToJSON(value?: AccessRequestApprovalType | null): any {
    return value as any;
}

export function AccessRequestApprovalTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AccessRequestApprovalType {
    return value as AccessRequestApprovalType;
}

